import isApiError from "@insite/client-framework/Common/isApiError";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    invalidAddressException,
    updateCart,
} from "@insite/client-framework/Services/CartService";
import { chain, 
    UpdateCart } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetCheckoutPaymentMethod";

replaceInChain(chain, UpdateCart, async props => {
    
    /* Poolcorp Custom Code */
    const isPaymentMethodCardOnFile = 
        props.apiParameter.cart.paymentMethod?.name === props.apiParameter.cart.properties.cardOnFilePaymentKey 
        && props.apiParameter.cart.properties.cardOnFilePaymentKey !== "";
    if (!isPaymentMethodCardOnFile && props.apiParameter.cart.properties.creditCardOnFileToken) {
        props.apiParameter.cart = {
            ...props.apiParameter.cart,
            properties: {
                ...props.apiParameter.cart.properties,
                creditCardOnFileToken: "",
            },
        };
    }
    /* Poolcorp Custom Code */

    try {
        await updateCart(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400 && error.errorJson.message === invalidAddressException) {
            return false;
        }
        throw error;
    }
});
